import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import axios from 'axios'
import GameCard from '../components/GameCard'
import './FavoritesPage.css'

export default function FavoritesPage() {
  const [favorites, setFavorites] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    loadFavorites()
  }, [])

  const loadFavorites = async () => {
    try {
      const response = await axios.get('/api/favorites', { withCredentials: true })
      setFavorites(response.data)
    } catch (error) {
      console.error('Failed to load favorites:', error)
    } finally {
      setLoading(false)
    }
  }

  const removeFavorite = async (gameId) => {
    try {
      await axios.delete(`/api/favorites/${gameId}`, { withCredentials: true })
      setFavorites(favorites.filter(f => f.game_id !== gameId))
    } catch (error) {
      console.error('Failed to remove favorite:', error)
    }
  }

  if (loading) {
    return (
      <div className="page-container">
        <div className="container">
          <div className="favorites-loading">
            <div className="spinner"></div>
            <p>Loading favorites...</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <motion.div
      className="page-container"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      <div className="container">
        <div className="favorites-header">
          <h1 className="page-title">⭐ My Favorite Games</h1>
          <p className="favorites-count">
            {favorites.length === 0
              ? 'No favorites yet!'
              : `${favorites.length} favorite${favorites.length === 1 ? '' : 's'}`}
          </p>
        </div>

        {favorites.length === 0 ? (
          <motion.div
            className="favorites-empty"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="empty-icon">☆</div>
            <h2>No favorites yet!</h2>
            <p>Click the ⭐ button on any game page to add it to your favorites.</p>
            <Link to="/" className="btn btn-primary">
              Discover Games
            </Link>
          </motion.div>
        ) : (
          <div className="favorites-grid">
            {favorites.map((favorite, index) => (
              <motion.div
                key={favorite.favorite_id}
                className="favorite-item"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
              >
                <Link to={`/game/${favorite.game_id}`} className="favorite-card">
                  {favorite.game_cover_url ? (
                    <div className="favorite-cover">
                      <img src={favorite.game_cover_url} alt={favorite.game_name} />
                    </div>
                  ) : (
                    <div className="favorite-cover favorite-cover-placeholder">
                      <span>🎮</span>
                    </div>
                  )}
                  <div className="favorite-info">
                    <h3 className="favorite-title">{favorite.game_name}</h3>
                    <span className="favorite-date">
                      Added {new Date(favorite.created_at).toLocaleDateString()}
                    </span>
                  </div>
                </Link>
                <motion.button
                  className="remove-favorite-btn"
                  onClick={(e) => {
                    e.preventDefault()
                    if (window.confirm(`Remove ${favorite.game_name} from favorites?`)) {
                      removeFavorite(favorite.game_id)
                    }
                  }}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  title="Remove from favorites"
                >
                  🗑️
                </motion.button>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  )
}
